export const tokenKey = "openid.token";
export const emailKey = "emailId";
